"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SimpleAPIError_1 = require("./SimpleAPIError");
/**
 * An instance of an API error but specifically for a validation error.
 */
var SimpleAPIValidationError = /** @class */ (function (_super) {
    __extends(SimpleAPIValidationError, _super);
    function SimpleAPIValidationError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get the name of the field that's thrown this error.
     * @returns {String|null}
     */
    SimpleAPIValidationError.prototype.getField = function () {
        if (this.data.hasOwnProperty("meta") &&
            this.data.meta.hasOwnProperty("field")) {
            return this.data.meta.field.replace("[", "").replace("]", "");
        }
        return null;
    };
    /**
     * Get a message that represents the field name and standard message
     * @returns {String}
     */
    SimpleAPIValidationError.prototype.getSingleMessage = function () {
        if (this.getField() !== null && this.getField() !== "") {
            return "There was an error with the field  '" + this.getField() + "': " + _super.prototype.getMessage.call(this);
        }
        return _super.prototype.getMessage.call(this);
    };
    return SimpleAPIValidationError;
}(SimpleAPIError_1.SimpleAPIError));
exports.SimpleAPIValidationError = SimpleAPIValidationError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2ltcGxlQVBJVmFsaWRhdGlvbkVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL0FQSS9TaW1wbGVBUEkvRXJyb3JzL1NpbXBsZUFQSVZhbGlkYXRpb25FcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQSxtREFBa0Q7QUFFbEQ7O0dBRUc7QUFDSDtJQUE4Qyw0Q0FBYztJQUE1RDs7SUF5QkEsQ0FBQztJQXhCQzs7O09BR0c7SUFDSSwyQ0FBUSxHQUFmO1FBQ0UsSUFDRSxJQUFJLENBQUMsSUFBSSxDQUFDLGNBQWMsQ0FBQyxNQUFNLENBQUM7WUFDaEMsSUFBSSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsY0FBYyxDQUFDLE9BQU8sQ0FBQyxFQUN0QztZQUNBLE9BQU8sSUFBSSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxHQUFHLEVBQUUsRUFBRSxDQUFDLENBQUMsT0FBTyxDQUFDLEdBQUcsRUFBRSxFQUFFLENBQUMsQ0FBQztTQUMvRDtRQUNELE9BQU8sSUFBSSxDQUFDO0lBQ2QsQ0FBQztJQUVEOzs7T0FHRztJQUNJLG1EQUFnQixHQUF2QjtRQUNFLElBQUksSUFBSSxDQUFDLFFBQVEsRUFBRSxLQUFLLElBQUksSUFBSSxJQUFJLENBQUMsUUFBUSxFQUFFLEtBQUssRUFBRSxFQUFFO1lBQ3RELE9BQU8seUNBQXVDLElBQUksQ0FBQyxRQUFRLEVBQUUsV0FBTSxpQkFBTSxVQUFVLFdBQUksQ0FBQztTQUN6RjtRQUNELE9BQU8saUJBQU0sVUFBVSxXQUFFLENBQUM7SUFDNUIsQ0FBQztJQUNILCtCQUFDO0FBQUQsQ0FBQyxBQXpCRCxDQUE4QywrQkFBYyxHQXlCM0Q7QUF6QlksNERBQXdCIn0=